module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card m-t-6"
  }, [(_vm.activity.images) ? _c('div', [(_vm.activity.images.data.length > 0) ? _c('div', [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.activity.images.data[0].thumbnail_path,
      "alt": "Card image cap"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.t('Translation not available')))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.t('There\'s not yet an available translation for this activity.')) + " "), _c('br'), _vm._v(_vm._s(_vm.t('Change language or search for another activity.')))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e8df8d04", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8df8d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/ActivityWithoutTranslation.vue
// module id = 807
// module chunks = 3